import {CardContent, Typography, css, styled} from '@mui/material';
import {StyledCardContentProps} from './types';

export const StyledCardContent = styled(CardContent)<StyledCardContentProps>`
	padding: 8px 16px;
	margin-bottom: 8px;

	${({$noPadding}) =>
		$noPadding &&
		css`
			padding: 0px;

			&:last-child {
				padding-bottom: 0px;
			}
		`}
`;

export const StyledTypography = styled(Typography)`
	margin-block: 0px;
	overflow-wrap: break-word;
`;
